// Product Information Page Enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Initialize custom slideshow
  initializeCustomSlideshow();
  
  // Enhanced hover effects for existing elements
  enhanceHoverEffects();
  
  // Smooth scrolling for anchor links
  enableSmoothScrolling();
  
  // Keyboard navigation
  enableKeyboardNavigation();
});

// Custom Slideshow Implementation
function initializeCustomSlideshow() {
  const mediaContainer = document.querySelector('.product-information__media');
  if (!mediaContainer) return;

  // Get all product images
  const productImages = document.querySelectorAll('.product-information__media .product-image');
  if (productImages.length <= 1) return;

  // Create slideshow structure around existing images
  const slideshowHTML = `
    <div class="custom-slideshow">
      <div class="slides-container">
        ${Array.from(productImages).map((img, index) => `
          <div class="slide ${index === 0 ? 'active' : ''}" data-slide="${index}">
            <img src="${img.src}" alt="${img.alt || 'Product image'}" loading="${index === 0 ? 'eager' : 'lazy'}" width="800" height="600">
          </div>
        `).join('')}
      </div>
      
      ${productImages.length > 1 ? `
        <button class="slideshow-nav prev" aria-label="Previous image">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="slideshow-nav next" aria-label="Next image">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="slideshow-counter">
          <span class="current-slide">1</span>/<span class="total-slides">${productImages.length}</span>
        </div>
      ` : ''}
    </div>
  `;

  // Replace the container content with slideshow
  const container = mediaContainer.querySelector('.custom-slideshow-container');
  if (container) {
    container.innerHTML = slideshowHTML;
  }

  // Initialize slideshow functionality
  const slideshow = mediaContainer.querySelector('.custom-slideshow');
  const slides = slideshow.querySelectorAll('.slide');
  const prevBtn = slideshow.querySelector('.prev');
  const nextBtn = slideshow.querySelector('.next');
  const currentSlideSpan = slideshow.querySelector('.current-slide');
  
  let currentSlide = 0;
  const totalSlides = slides.length;

  // Function to show slide
  function showSlide(index) {
    // Remove active class from all slides
    slides.forEach(slide => slide.classList.remove('active'));
    
    // Add active class to current slide
    slides[index].classList.add('active');
    
    // Update counter
    if (currentSlideSpan) {
      currentSlideSpan.textContent = index + 1;
    }
    
    currentSlide = index;
  }

  // Next slide function
  function nextSlide() {
    const nextIndex = (currentSlide + 1) % totalSlides;
    showSlide(nextIndex);
  }

  // Previous slide function
  function prevSlide() {
    const prevIndex = (currentSlide - 1 + totalSlides) % totalSlides;
    showSlide(prevIndex);
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!mediaContainer.contains(document.activeElement)) return;
    
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextSlide();
    }
  });

  // Touch/swipe support for mobile
  let startX = 0;
  let endX = 0;

  slideshow.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  slideshow.addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].clientX;
    handleSwipe();
  });

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  }

  // Auto-advance slideshow (optional)
  let autoAdvanceInterval;
  
  function startAutoAdvance() {
    autoAdvanceInterval = setInterval(nextSlide, 5000); // 5 seconds
  }
  
  function stopAutoAdvance() {
    clearInterval(autoAdvanceInterval);
  }

  // Start auto-advance when user is not interacting
  startAutoAdvance();
  
  // Stop auto-advance on user interaction
  slideshow.addEventListener('mouseenter', stopAutoAdvance);
  slideshow.addEventListener('mouseleave', startAutoAdvance);
  slideshow.addEventListener('focusin', stopAutoAdvance);
  slideshow.addEventListener('focusout', startAutoAdvance);
}

// Enhanced hover effects for existing elements
function enhanceHoverEffects() {
  // Pricing options hover effects
  const pricingOptions = document.querySelectorAll('.pricing-option');
  pricingOptions.forEach(option => {
    option.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
      this.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
    });
    
    option.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
    });
  });

  // Supplement facts button hover effects
  const supplementFactsButtons = document.querySelectorAll('.supplement-facts-button');
  supplementFactsButtons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-1px)';
      this.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
    });
  });

  // Enhanced existing Shopify variant picker and buy buttons
  const variantOptions = document.querySelectorAll('.variant-picker .variant-option');
  variantOptions.forEach(option => {
    option.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-1px)';
      this.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
    });
    
    option.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)';
    });
  });

  // Enhanced buy buttons
  const buyButtons = document.querySelectorAll('.product-form-buttons .button');
  buyButtons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-1px)';
      this.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.2)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
    });
  });

  // Enhanced accelerated checkout buttons
  const acceleratedButtons = document.querySelectorAll('shopify-accelerated-checkout .button');
  acceleratedButtons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-1px)';
      this.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
    });
  });
}

// Smooth scrolling for anchor links
function enableSmoothScrolling() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

// Keyboard navigation
function enableKeyboardNavigation() {
  document.addEventListener('keydown', function(e) {
    // Tab navigation for slideshow
    if (e.key === 'Tab') {
      const slideshow = document.querySelector('.custom-slideshow');
      if (slideshow) {
        const focusableElements = slideshow.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        if (e.shiftKey && document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }
  });
}

// Loading states for buttons
function addLoadingStates() {
  const buttons = document.querySelectorAll('.button, shopify-accelerated-checkout .button');
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      if (!this.disabled) {
        this.style.opacity = '0.7';
        this.style.pointerEvents = 'none';
        
        // Reset after a short delay (simulating loading)
        setTimeout(() => {
          this.style.opacity = '1';
          this.style.pointerEvents = 'auto';
        }, 1000);
      }
    });
  });
}

// Initialize loading states
document.addEventListener('DOMContentLoaded', addLoadingStates);

// Console log for debugging
console.log('Product Information JavaScript loaded successfully'); 